import { MINIMUM_TIME_REQUIRED_MONTHS } from "./constants";
import i18n from "@Shared/@i18n";
import { helpers } from "@vuelidate/validators";
export const minTimeAt = (field, min = MINIMUM_TIME_REQUIRED_MONTHS, soft = true) => {
  return {
    $valid: value => {
      let total;
      if (typeof value === "object") {
        total = !(value != null && value[field]) ? 0 : value[field];
      } else total = value;
      return total >= min || soft;
    },
    $message: $params => {
      return errorMessages.minTimeAt.soft(field || $params.$validator);
    },
    $response: $model => {
      return {
        warning: $model < min
      };
    },
    $params: {
      min,
      softError: soft,
      field
    }
  };
};
export const minValueNotRequired = (min, isRequired = true) => helpers.withParams({
  min
}, value => {
  if (isRequired) return value >= min;
  return value >= min || !value;
});
const errorMessages = {
  minTimeAt: {
    full: field => {
      switch (field) {
        case "time-at":
          return i18n.t("form-validations.total36MonthsResidences");
        case "time-at-job":
          return i18n.t("form-validations.total36MonthsEmployment");
        default:
          return "";
      }
    },
    soft: field => {
      switch (field) {
        case "time-at":
          return i18n.t("form-validations.total36MonthsResidences");
        case "time-at-job":
          return i18n.t("form-validations.total36MonthsEmployment");
        default:
          return "";
      }
    }
  }
};